import type { FC } from 'react';

import { useEditStore } from '@xing-com/crate-entity-pages-entity-pages-shared-context-edit-context';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { useHeaderContext } from '../../hooks/use-header-context/use-header-context';
import { EditLogoMenu } from '../edit/edit-logo/edit-logo-menu';

import * as Styled from './logo-area.styles';

export const LogoArea: FC = () => {
  const { title } = useHeaderContext();
  const { pageContext } = usePageContext();
  const isEditing = useEditStore(({ isEditing }) => isEditing);

  return (
    <Styled.LogoArea>
      <Styled.LogoImageContainer
        profileName={title}
        src={pageContext.logo}
        type="company"
        variant="responsive"
        data-cy="LOGO_IMAGE"
      />
      {isEditing && !pageContext.isInsiderPage ? <EditLogoMenu /> : null}
    </Styled.LogoArea>
  );
};
